import { useNavigate } from "react-router-dom";
import { axiosService } from '../helpers/axios';
import { refreshUserData, clearUserData } from '../contexts/UserContext';


function useUserActions() {
  const navigate = useNavigate();

  return {
    login,
    register,
    logout,
    edit,
    socialLogin,
  };

  async function login(data) {
    const res = await axiosService.post("/auth/login/", data);

    // Seed the SWR cache directly with the user from the login response.
    // This avoids a race condition where ProtectedRoute renders before
    // a separate GET /users/me/ revalidation completes.
    if (res.data?.user) {
      await refreshUserData(res.data.user);
      // Signal to other windows that a (potentially different) user has logged in.
      // The storage event fires in all OTHER open windows, causing them to revalidate
      // their own /users/me/ so their page content and notifications stay consistent.
      localStorage.setItem('otable_auth_uid', String(res.data.user.id));
    } else {
      await refreshUserData();
    }
    return res.data;
  }

  async function register(data) {
    const res = await axiosService.post("/auth/register/", data);
    await refreshUserData();
    navigate("/");
    return res.data;
  }

  async function logout() {
    try {
      await axiosService.post("/auth/logout/");
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      localStorage.removeItem('otable_auth_uid');
      await clearUserData();
      navigate("/login/");
    }
  }

  async function edit(data) {
    const res = await axiosService.patch("/users/me/", data);
    await refreshUserData();
    return res.data;
  }

  // Social / OAuth2 login
  async function socialLogin(provider, code, redirectUri) {
    const res = await axiosService.post(
      `/auth/social/${provider}/callback/`,
      { code, redirect_uri: redirectUri }
    );
    await refreshUserData();
    return res.data;
  }
}


export { useUserActions };

// Note: Tokens are stored in HttpOnly cookies, not accessible from JavaScript
